// extracted by mini-css-extract-plugin
export default {"link":"_ge21ka","box-link":"_1kolkx8","boxLink":"_1kolkx8"};